module.exports = __webpack_public_path__ + "assets/6f8107499f9dd222961901e0b974d1ae.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/reel/reel.mp3
 ** module id = 215
 ** module chunks = 0
 **/